import { Request } from '@/api/core'
import { API_CONFIG } from '@/config/api'

/** 后端 API 请求实例 */
export const request = new Request(API_CONFIG, true)
